import { Box, Container } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { filterUsers } from '../../../../../redux/actions/users'
import { IRootState } from '../../../../../redux/types'
import Header from '../../../../shared/components/Header'
import NotFilter from '../../../../shared/components/NotFilter'
import CountriesFilter from '../../../../shared/components/filters/CountryFilter'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import SubHeader from '../../../../shared/styles/Subheader'
import { RoleMenuFilter } from '../components/RoleMenuFilter'
import UserNotifications from '../components/UserNotifications'
import UserTable from '../components/UserTable'
import { UserTableTitle } from '../components/UserTableTitle'
import AdminUserFilter from '../components/modals/AdminUserFilter'
import UserModal from '../components/modals/create/UserModal'
import UserMassivelyAssign from '../components/modals/massive-assign/UserMassivelyAssign'
import { useInitialState } from '../hooks/useInitialState'
import { useUserFilters } from '../hooks/useUserFilters'

function Users() {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()
  const isMobile = useScreenWidth(700)

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { users, reload, error, loading } = useSelector((state: IRootState) => state.user)

  useInitialState()
  const { filters, setFilters, userIds, setUserIds, optionsData, handleChangeFilter, handleClearFilters } = useUserFilters()

  useEffect(() => {
    if (reload && !error && filters.role_id !== 0) {
      dispatch(filterUsers(filters))
      setUserIds([])
    }
  }, [reload])

  const handleClickSetOptions = (options: any) => {
    if (authUser !== null && filters.role_id !== 0) setFilters({ ...filters, filterBy: options })
  }

  const noResults = users.length === 0 && !loading
  return (
    <>
      <Header title={t('admin.people.people')} />
      <SubHeader>
        <RoleMenuFilter filters={filters} handleChangeFilter={handleChangeFilter} />
      </SubHeader>

      <Container id="user-admin-container">
        <Box mt={isMobile ? 2 : 6} gap={3} display="flex" flexDirection={isMobile ? 'column-reverse' : 'column'}>
          <UserTableTitle filters={filters} />
          <Box>
            <Grid container justifyContent="space-between" spacing={1}>
              <Grid sx={theme => ({ [theme.breakpoints.down('sm')]: { justifyContent: 'center' } })} xs={5} sm={6}>
                {userIds.length > 0 ? <UserMassivelyAssign userIds={userIds} /> : <UserModal role_id={filters.role_id} />}
              </Grid>
              <Grid
                sx={theme => ({
                  display: 'flex',
                  justifyContent: 'flex-end',
                  [theme.breakpoints.down('sm')]: {
                    justifyContent: 'center'
                  }
                })}
                xs={7}
                sm={6}
              >
                <AdminUserFilter data={optionsData} handleClick={handleClickSetOptions} />
                <CountriesFilter />
              </Grid>
            </Grid>
          </Box>
        </Box>

        {noResults ? (
          <NotFilter subsection={null} handleClearFilters={handleClearFilters} />
        ) : (
          <Box mt={2} mb={5}>
            <UserTable userIds={userIds} setUserIds={setUserIds} filters={filters} />
          </Box>
        )}

        <UserNotifications />
      </Container>
    </>
  )
}

export default Users
